export const namespaced = true

export const state = {
  activity: [
    {
      text:
        'What a great crew we have, we have to work together to pull this off.'
    }
  ],
  loading: false
}
export const mutations = {
  RESET_ACTIVITY(state) {
    state.activity = []
  },
  ADD_ACTIVITY(state, { activity }) {
    state.activity.push(activity)
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  }
}
export const actions = {
  addActivity({ commit }, text) {
    return new Promise(resolve => {
      console.log(`🔉🔉 Adding activity: "${text}"`)

      commit('ADD_ACTIVITY', { activity: { text: text } })

      resolve(true)
    })
  }
}
export const getters = {}
